/* file description */

import * as React from 'react';
import { useEffect, useState, useRef, useMemo } from 'react';
import SPGroupForm from '@/components/SPGroupForm';
import { Button, Tabs, Typography } from 'antd';
import { TabPagePropsType, TableRefType } from '../type';
import { useSPFormWithModelSchema } from '@/asset/AssetTask/templates/Cascade/effect/useSPFormWithModelSchema';
import useValuesStore from '@/store/useValuesStore';
import styles from '../index.module.less';
import { SPTableList } from '@/components/SPTableList';
import { useFreeComponents } from '@/asset/AssetTask/templates/Cascade/effect';
import FormFreeButtonWarp from './FormFreeButtonWarp';
import useMetaStore from '@/store/useMetaStore';

const { Title } = Typography;

const TabPage: React.FC<TabPagePropsType> = (props) => {
  const {
    value,
    rowId,
    refList,
  } = props;

  const store = useValuesStore();
  const { values, setValues } = store;
  const sotreState = useMetaStore();

  // 生成form的props
  const spRecordSchema = useSPFormWithModelSchema({
    schemaList: props.schema,
    metaInfoByRule: sotreState.metaInfoByRule,
  });


  // TODO 直接对数据操作，可能存在异常
  const onHeadChange = (allValue) => {
    let newValue = [...values[spRecordSchema.props.moduleID]];
    newValue = newValue.map((v) => {
      if (v._id === rowId) {
        return Object.assign({}, v, allValue);
      } else {
        return v;
      }
    });
    setValues(spRecordSchema.props.moduleID, newValue);
  };

  const { extralComponents } = useFreeComponents({
    relationSchema: props.schema,
    index: (values?.[props.schema.code] as Object[])?.findIndex((item: any) => item._id === rowId),
  });

  return (
    <div className="TABPAGE">
      <div className={styles.secendHead}>
        {/* <Title level={4}>{spRecordSchema?.title}</Title> */}
        <FormFreeButtonWarp
          refList={refList}
          moduleId={spRecordSchema.props.moduleID}
          rowId={rowId}
        >
          <SPGroupForm
            {...spRecordSchema.props}
            isMobile={sotreState.isMobile}
            value={{ ...value }}
            onValuesChange={(changeValue, allValue) => {
              onHeadChange(allValue);
            }}
            extral={extralComponents}
            storeValue={values}
            store={store}
          />
        </FormFreeButtonWarp>
      </div>
      {
      props.schema.children && <SPTableList
        headModuleId={props.schema.code}
        schema={props.schema.children}
        rowId={rowId}
        refList={refList}
      />
      }
    </div>
  );
};
TabPage.displayName = 'TabPage';

export default TabPage;
